<template>
  <v-container fluid class="vertrags-header pa-0">
    <div class="ueber primary--text white pt-12 pb-6">{{ pageName }}</div>
    <v-row class="bg-dimmed pa-6 mb-12 round-corners flex-nowrap"
           no-gutters>
      <v-col cols="6">
        <div class="ueber2 primary--text">{{ kundenName }}</div>
        <div>Vertragsnummer: {{ vertragsnummer }}</div>
      </v-col>
      <v-col cols="6"
             class="text-right my-auto">

        <slot name="details-right" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "VertragsHeader",
  props: {
    kundenName: {
      type: String,
      required: true
    },
    vertragsnummer: {
      type: String,
      required: true
    },
    pageName: {
      type: String,
      required: true
    }
  }
};
</script>

<style>

.scroll-up .vertrags-header {
  position: sticky;
  top: 136px;
}

.scroll-down .vertrags-header {
  position: sticky;
  top: 48px;
}

@media screen and (max-width: 1100px) , screen and (max-height: 800px) {
  .vertrags-header {
    position: initial!important;
  }
}

</style>
